import { useMemo } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE_URL } from "../../lib/seo";

export default function Seo({
  title,
  metaTitle,
  description,
  canonicalPath,
  canonicalUrl,
  schema,
  image,
  type = "website",
  noindex = false,
}) {
  const location = useLocation();
  const resolvedTitle = metaTitle || title;
  const currentPathname = (location.pathname || canonicalPath || "/").startsWith("/")
    ? location.pathname || canonicalPath || "/"
    : `/${location.pathname || canonicalPath || "/"}`;
  const resolvedCanonical =
    canonicalUrl || (canonicalPath ? `${SITE_URL}${currentPathname}` : "");
  const normalizedSchema = useMemo(
    () => (schema ? (Array.isArray(schema) ? schema : [schema]) : []),
    [schema],
  );
  const schemaTags = useMemo(
    () =>
      normalizedSchema.map((item, index) => ({
        type: "application/ld+json",
        innerHTML: typeof item === "string" ? item : JSON.stringify(item),
        key: `schema-${index}`,
      })),
    [normalizedSchema],
  );

  return (
    <Helmet script={schemaTags}>
      {resolvedTitle ? <title>{resolvedTitle}</title> : null}
      {resolvedTitle ? <meta property="og:title" content={resolvedTitle} /> : null}
      {description ? <meta name="description" content={description} /> : null}
      {description ? <meta property="og:description" content={description} /> : null}
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      {!noindex && resolvedCanonical ? <link rel="canonical" href={resolvedCanonical} /> : null}
      {resolvedCanonical ? <meta property="og:url" content={resolvedCanonical} /> : null}
      <meta property="og:type" content={type} />
      {image ? <meta property="og:image" content={image} /> : null}
      {image ? <meta name="twitter:image" content={image} /> : null}
      {resolvedTitle ? <meta name="twitter:title" content={resolvedTitle} /> : null}
      {description ? <meta name="twitter:description" content={description} /> : null}
    </Helmet>
  );
}
